'use client'

import { Typo3_834 } from '@/types'
import { Button, Title } from '@/ui/components'

interface Props {
  data: Typo3_834['footer']['newsletter']
}

const Newsletter = ({ data }: Props) => (
  <div>
    {data?.title && (
      <Title as="h3" className={'h3'}>
        {data?.title}
      </Title>
    )}
    <Button
      href={data?.button.link.href}
      target={data?.button?.link?.target || undefined}
      className="mt-lg"
    >
      {data?.button.label}
    </Button>
  </div>
)

export default Newsletter
